module.exports = __webpack_public_path__ + "img/cat-empty-blank-document.775662ed.svg";